import { ref, computed } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33e87ba7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "third-party-price-panel"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "默认价格", -1));
const _hoisted_3 = {
  key: 0,
  class: "third-party-tips-text"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "third-party-tips-text"
}, "*折扣描述会显示在游戏收银台页面，若需自定义描述，建议使用英文谨慎修改;", -1));
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { DEFAULT_MISSING_OFFICIAL_TIP, buildPromotionDesc, calcDiscountRate, validateChannelPrice } from '../services/thirdPartyPricing';
export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyPricePanel',
  props: {
    modelValue: null,
    officialPrice: {
      default: ''
    },
    missingOfficialTip: {
      default: DEFAULT_MISSING_OFFICIAL_TIP
    },
    channelName: {
      default: 'Xsolla'
    },
    priceTip: {
      default: ''
    },
    showDiscount: {
      type: Boolean,
      default: true
    },
    showPriceTips: {
      type: Boolean,
      default: true
    },
    allowAboveOfficial: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "price-commit"],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    // 三方渠道（Xsolla / EnjoyPay）价格面板：渠道只作为文案变量传入，价格口径与校验两个渠道完全一致
    const priceError = ref('');
    const discountRate = computed(() => calcDiscountRate(props.officialPrice, props.modelValue.prodPrice));
    // 描述跟着价格实时走，和折扣同步；人工改过的描述会被下一次改价覆盖（描述本就允许再改）
    const onPriceInput = prodPrice => {
      const price = prodPrice || '';
      emit('update:modelValue', {
        ...props.modelValue,
        prodPrice: price,
        promotionDesc: buildPromotionDesc(props.officialPrice, price)
      });
      if (priceError.value) priceError.value = '';
    };
    // 失焦做校验并通知价格落定；描述在输入时已经同步过
    const onPriceCommit = () => {
      priceError.value = validateChannelPrice(props.officialPrice, props.modelValue.prodPrice, props.missingOfficialTip, props.allowAboveOfficial);
      emit('price-commit');
    };
    const onDescInput = promotionDesc => {
      emit('update:modelValue', {
        ...props.modelValue,
        promotionDesc: promotionDesc || ''
      });
    };
    // 官方价变动（改默认价 / 切层级）后由页面调用：只刷新描述，不弹校验
    const refreshPromotionDesc = () => {
      const desc = buildPromotionDesc(props.officialPrice, props.modelValue.prodPrice);
      if (desc) emit('update:modelValue', {
        ...props.modelValue,
        promotionDesc: desc
      });
    };
    const validate = () => {
      priceError.value = validateChannelPrice(props.officialPrice, props.modelValue.prodPrice, props.missingOfficialTip, props.allowAboveOfficial);
      return !priceError.value;
    };
    const clearValidate = () => {
      priceError.value = '';
    };
    expose({
      validate,
      clearValidate,
      refreshPromotionDesc
    });
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form_item, {
        required: "",
        "validate-status": priceError.value ? 'error' : '',
        help: priceError.value || undefined
      }, {
        label: _withCtx(() => [_hoisted_2, __props.priceTip ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 0,
          placement: "right"
        }, {
          title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(__props.priceTip), 1)]),
          default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
            class: "third-party-info-icon"
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createVNode(_component_a_input_number, {
          value: __props.modelValue.prodPrice,
          step: 0.01,
          controls: false,
          precision: 2,
          "string-mode": "",
          disabled: __props.disabled,
          class: "third-party-default-price",
          "addon-after": "USD",
          "onUpdate:value": onPriceInput,
          onBlur: onPriceCommit
        }, null, 8, ["value", "step", "disabled"]), __props.showPriceTips ? (_openBlock(), _createElementBlock("span", _hoisted_3, " *三方价格不得低于官方价格的7折，且建议价格设置不低于1.99美元，否则" + _toDisplayString(__props.channelName) + "佣金将高于iOS; ", 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["validate-status", "help"]), __props.showDiscount ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_a_form_item, {
        label: "折扣"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input_number, {
          value: _unref(discountRate),
          controls: false,
          precision: 0,
          readonly: "",
          class: "third-party-discount",
          "addon-after": "%"
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "折扣描述"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          class: "third-party-promotion-desc",
          value: __props.modelValue.promotionDesc,
          disabled: __props.disabled,
          placeholder: "请输入折扣描述",
          "onUpdate:value": onDescInput
        }, null, 8, ["value", "disabled"]), _hoisted_4]),
        _: 1
      })], 64)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "extra")]);
    };
  }
});